export default __webpack_public_path__ + "static/media/762.8889f251.png";